// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"407":"b91460c8","682":"3fee748f","687":"01cf0840","836":"9c77cd56","924":"f17526c1","992":"bcba0470"}[chunkId] + ".chunk.css";
};